export default __webpack_public_path__ + "static/media/linkedin-icon.35f5ef30.svg";